import React from 'react'
import IDonor from '@interfaces/IDonor'
import ICustomImportDonor from '@interfaces/ICustomImportDonor'
import DonorCardBase from './DonorCardBase'

interface ReservationDonorCardProps {
  donor: IDonor | ICustomImportDonor
  position: number
  selectedTreatment?: string
  isLast?: boolean
  showPhotoMatchColumn?: boolean
  isPhotoMatchEligible?: boolean
  disableLink?: boolean
}

const ReservationDonorCard: React.FC<ReservationDonorCardProps> = ({
  donor,
  position,
  selectedTreatment,
  isLast,
  showPhotoMatchColumn,
  isPhotoMatchEligible,
  disableLink,
}) => {
  return (
    <DonorCardBase
      donor={donor}
      position={position}
      variant="reservation"
      treatmentDisplayMode="reserved"
      selectedTreatment={selectedTreatment}
      isDraggable={false}
      isLast={isLast}
      showPhotoMatchColumn={showPhotoMatchColumn}
      isPhotoMatchEligible={isPhotoMatchEligible}
      disableLink={disableLink}
    />
  )
}

export default ReservationDonorCard
